import api from './index';
//
let exports = {};

//==========================商户付款时机==========================
exports.getMerchantPayTimingList = function (data, callback) {// 获取商户付款时机列表
    api.post('/merchtFinac/merchant/pay/timing/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

//==========================商户付款方式==========================

exports.getMerchantPayWayList = function (data, callback) {// 获取商户付款方式列表
    api.post('/merchtFinac/merchant/pay/way/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

//==========================商户发票类型==========================

//=============================商户（支持的）发票内容标签==============================

//=============================发票主体信息==============================
exports.getMerchantInvoiceSubjectByUkAvailable = function (data, callback) {// 根据唯一键获取为禁用的发票主体信息
    api.post('/merchtFinac/merchant/invoice/subject/get/by/uk/available')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.getMerchantInvoiceSubjectList = function (data, callback) {// 获取商户发票主体信息列表
    api.post('/merchtFinac/merchant/invoice/subject/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.updateMerchantInvoiceSubject = function (data, callback) {// 根据id修改发票主体信息
    api.post('/merchtFinac/merchant/invoice/subject/update/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.deleteMerchantInvoiceSubject = function (params, callback) {// 根据id删除发票主体信息
    api.post('/merchtFinac/merchant/invoice/subject/delete/do')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getMerchantInvoiceSubject = function (params, callback) {// 根据id查询发票主体信息
    api.get('/merchtFinac/merchant/invoice/subject/get')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};
exports.saveMerchantInvoiceSubject = function (data, callback) {// 保存发票主体信息
    api.post('/merchtFinac/merchant/invoice/subject/save/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.updateMerchantInvoiceSubjectDisabled = function (data, callback) {// 发票主题信息的启用/禁用
    api.post('/merchtFinac/merchant/invoice/subject/disabled/update/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.updateMerchantInvoiceSubjectForDefaulted = function (data, callback) {// 发票主题信息的默认
    api.post('/merchtFinac/merchant/invoice/subject/defaulted/update/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.validateInvoiceSubjecImpFile = function (data, callback) {
    api.post('/merchtFinac/imp/file/invoice/subject/validate')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.saveInvoiceSubjectAcctList = function (data, callback) {
    api.post('/merchtFinac/invoice/subject/list/save')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

//获取商户发票类型列表
exports.getMerchantInvoiceTypeListAvailable = function (params, callback) {// 获取商户发票类型列表
    api.post('/merchtFinac/merchant/invoice/type/list/get/available')
        .data(params)
        .done(callback)
        .go();
};

//获取商户发票内容标签列表
exports.getMerchantInvoiceCtntTagList = function (params, callback) {// 获取商户发票内容标签列表
    api.post('/merchtFinac/merchant/invoice/ctnt/tag/list/get')
        .data(params)
        .done(callback)
        .go();
};
exports.getEnabledMerchantPayWayList = function (data, callback) {// 获取服务商未禁用的付款方式列表
    api.post('/merchtFinac/merchant/enabled/pay/way/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getMerchantPayTimingListAvailable = function (data, callback) {// 获取服务商未禁用的付款时机列表
    api.post('/merchtFinac/merchant/pay/timing/list/get/available')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/merchtFinac.js
// module id = 82
// module chunks = 0